import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { DocumentTypeAttribute } from '../../../models/documentTypeAttribute.model';
import { QueryOperators } from '../../models/DocumentFilterAttribute';

@Component({
  selector: 'app-date-attribute',
  templateUrl: './date-attribute.component.html',
  styleUrls: ['./date-attribute.component.css']
})
export class DateAttributeComponent implements OnInit, OnChanges {
  isDisabled = false;

  @Input() documentAttribute: DocumentTypeAttribute;
  @Input() operator: string;
  @Input() useMandatory = true;
  @Input() disabled = false;
  @Input() label: string;
  @Input() startView = 'month';

  public form: FormGroup;
  public queryOperators: QueryOperators;

  constructor(
    private controlContainer: ControlContainer
  ) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.form = <FormGroup>this.controlContainer.control;    
    const value = this.form.get('value');
    this.isDisabled = value.disabled;
  }

  ngOnInit() {
    this.form = <FormGroup>this.controlContainer.control;    
    const operator = this.form.get('operator');
    const value = this.form.get('value');
    this.isDisabled = value.disabled;    
    if (!(operator.value)) {
      operator.setValue(this.operator);  
    }        
  }
  cearValue(evt: MouseEvent) {
    const value = this.form.get('value');
    value.setValue(null);
    evt.stopPropagation();
  }
  cearMin(evt: MouseEvent) {
    const min = this.form.get('min');
    min.setValue(null);
    evt.stopPropagation();
  }
  cearMax(evt: MouseEvent) {
    const max = this.form.get('max');
    max.setValue(null);
    evt.stopPropagation();
  }
}
